<template>
  <boxwrap class="window-details--inner">
    <boxwrap-header>
      <boxwrap-header-items class="window-detail-title">
        <i class="ico--agent"></i>
        <span>agent detail info</span>
      </boxwrap-header-items>

      <boxwrap-header-items class="date-info">
        <div class="date-info--inner">
          <div class="date-info-items">
            <span class="date-info-lbl">created date</span>
            <span class="date-info-date">{{agent.created_at | date}}</span>
          </div>

          <div class="date-info-items">
            <span class="date-info-lbl">last login</span>
            <span class="date-info-date">2019-01-01 00:00:00</span>
          </div>
        </div>
      </boxwrap-header-items>
    </boxwrap-header>

    <boxwrap-contents>
      <boxwrap-items class="window-details-info">
        <div class="details">
          <div class="detail-items -referral">
            <div class="detail-lbl">
              <span>referral</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span v-if="agent.referrer">{{agent.referrer.referrer_id}}</span>
                <span v-else>n/a</span>
              </div>

              <button class="btn--info"  @click="openAgentPopup()">
                <i class="ico--info"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -user-count">
            <div class="detail-lbl">
              <span>user count</span>
            </div>
            <div class="detail-data -nobutton">
              <div class="detail-data--inner">
                <span v-if="agent.users">{{agent.users.total | FormatAmount('whole')}}</span>
                <span v-else>0</span>
              </div>
            </div>
          </div>

          <div class="detail-items -code-count">
            <div class="detail-lbl">
              <span>code count</span>
            </div>
            <div class="detail-data -nobutton">
              <div class="detail-data--inner">
                <span v-if="agent.codes">{{agent.codes.total | FormatAmount('whole')}}</span>
                <span v-else>0</span>
              </div>
            </div>
          </div>

          <div class="detail-items -agent-id">
            <div class="detail-lbl">
              <span>agent id</span>
            </div>
            <div class="detail-data -nobutton">
              <div class="detail-data--inner">
                <span>
                  {{agent.login_id}}
                </span>
              </div>
            </div>
          </div>

          <div class="detail-items -agent-name">
            <div class="detail-lbl">
              <span>agent name</span>
            </div>
            <div class="detail-data -nobutton">
              <div class="detail-data--inner">
                <span>{{agent.login_name}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items -level">
            <div class="detail-lbl">
              <span>level</span>
            </div>
            <div class="detail-data -selectwithbutton">
              <select-list
                :title="agent.level.name"
                :withReset="true"
                v-if="agent.level"
                v-model="agent.level_id"
              >
                <select-option
                  v-for="level in levels"
                  :value="level.id"
                  :key="level.id"
                  :name="level.name"
                >
                  {{ level.name }}
                </select-option>
              </select-list>

              <button class="btn--info">
                <i class="ico--info"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -phone">
            <div class="detail-lbl">
              <span>phone</span>
            </div>
            <div class="detail-data">
              <div class="detail-data--inner">
                <span>{{agent.phone}}</span>
              </div>

              <button
                class="btn--edit"
                @click="showPhone=true"
              >
                <i class="ico--edit"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -password">
            <div class="detail-lbl">
              <span>password</span>
            </div>
            <div class="detail-data">
              <div class="detail-data--inner">
                <span>{{ showPassword }}</span>
              </div>

              <button
                class="btn--edit"
                @click="showPass = true"
              >
                <i class="ico--edit"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -status">
            <div class="detail-lbl">
              <span>status</span>
            </div>
            <div class="detail-data -selectwithbutton">
              <select-list
                title="Status"
              >
                <select-option

                >
                  status 1
                </select-option>
                <select-option

                >
                  status 2
                </select-option>
              </select-list>

              <button class="btn--info">
                <i class="ico--info"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -losing">
            <div class="detail-lbl">
              <span>losing</span>
            </div>
            <div class="detail-data">
              <div class="detail-data--inner">
                <span></span>
              </div>

              <button class="btn--info">
                <i class="ico--info"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -rolling">
            <div class="detail-lbl">
              <span>rolling</span>
            </div>
            <div class="detail-data">
              <div class="detail-data--inner">
                <span></span>
              </div>

              <button class="btn--info">
                <i class="ico--info"></i>
              </button>
            </div>
          </div>

          <div class="detail-items -commission-in">
            <div class="detail-lbl">
              <span>commission in</span>
            </div>
            <div class="detail-data -nobutton">
              <div class="detail-data--inner">
                <span></span>
              </div>
            </div>
          </div>

          <div class="detail-items -commission-out">
            <div class="detail-lbl">
              <span>commission out</span>
            </div>
            <div class="detail-data -nobutton">
              <div class="detail-data--inner">
                <span></span>
              </div>
            </div>
          </div>

          <div class="detail-items -commission-net">
            <div class="detail-lbl">
              <span>commission net</span>
            </div>
            <div class="detail-data -nobutton">
              <div class="detail-data--inner">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </boxwrap-items>

      <boxwrap-items class="window-details-data">
        <agent-details-tabs></agent-details-tabs>

        <div class="user-details-contents">
          <agent-info
            v-if="$route.params.tab === 'info'"
          >
          </agent-info>

          <agent-commission
            v-if="$route.params.tab === 'commission'"
          >
          </agent-commission>

          <agent-commission-out
            v-if="$route.params.tab === 'commission-out'"
          >
          </agent-commission-out>

          <agent-codes
            v-if="$route.params.tab === 'codes'"
          >
          </agent-codes>

          <agent-user-list
            v-if="$route.params.tab === 'user-list'"
          >
          </agent-user-list>

          <agent-bet-history
            v-if="$route.params.tab === 'bet-history'"
          >
          </agent-bet-history>

          <agent-cash-history
            v-if="$route.params.tab === 'cash-history'"
          >
          </agent-cash-history>
        </div>
      </boxwrap-items>
    </boxwrap-contents>

    <!-- modal for phone -->
    <modal
      class="modal--edit-phone"
      title="modify phone"
      :activate="showPhone"
      v-if="showPhone"
      @activate="showPhone=$event"
    >
      <template slot="body">
        <div class="details details-modal">
          <div class="detail-items">
            <div class="detail-lbl">
              <span>current phone</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{agent.phone}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>new phone</span>
            </div>
            <div class="detail-data">
              <div class="input-wrap">
                <input
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--modify -withlabel"
        >
          <i class="ico--save"></i>
          <span>Save</span>
        </button>
      </template>
    </modal>
    <!-- //end modal for phone -->

    <!-- modal for password -->
    <modal
      class="modal--edit-password"
      title="modify password"
      :activate="showPass"
      v-if="showPass"
      @activate="showPass=$event"
    >
      <template slot="body">
        <div class="details details-modal">
          <div class="detail-items">
            <div class="detail-lbl">
              <span>current password</span>
            </div>
            <div class="detail-data -disabled">
              <div class="detail-data--inner">
                <span>{{showPassword}}</span>
              </div>
            </div>
          </div>

          <div class="detail-items">
            <div class="detail-lbl">
              <span>new password</span>
            </div>
            <div class="detail-data">
              <div class="input-wrap">
                <input
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--modify -withlabel"
        >
          <i class="ico--save"></i>
          <span>Save</span>
        </button>
      </template>
    </modal>
    <!-- //end modal for password -->
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'

//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

//= components
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import AgentDetailsTabs from '@/components/common/agent-details/AgentDetailsTabs'

// tabs
import AgentInfo from '@/components/common/agent-details/AgentInfo'
import AgentCommission from '@/components/common/agent-details/AgentCommission'
import AgentCommissionOut from '@/components/common/agent-details/AgentCommissionOut'
import AgentCodes from '@/components/common/agent-details/AgentCodes'
import AgentUserList from '@/components/common/agent-details/AgentUserList'
import AgentBetHistory from '@/components/common/agent-details/AgentBetHistory'
import AgentCashHistory from '@/components/common/agent-details/AgentCashHistory'

import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'

export default {
  name: 'agent-details',

  components: {
    Pagination,
    Modal,
    AgentDetailsTabs,
    AgentInfo,
    AgentCommission,
    AgentCommissionOut,
    AgentCodes,
    AgentUserList,
    AgentBetHistory,
    AgentCashHistory
  },

  mixins: [ swal ],

  filters: {
    FormatAmount,

    formatVip (vip) {
      let v = ''

      switch (vip) {
        case 1:
          v = 'normal'
          break
        case 2:
          v = 'vip'
          break
        case 3:
          v = 'vvip'
          break
      }

      return v
    }
  },

  data () {
    let params = Object.assign(
      {
        rows: 5,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc'
      },
      this.$route.query
    )

    for (const key in params) {
      if (params.hasOwnProperty(key) && !isNaN(parseFloat(params[key]))) {
        params[key] = parseFloat(params[key])
      }
    }

    return {
      params,
      agents: [],
      agent: {},
      manualUsers: [],
      count: 1,
      selected: [],
      showPass: false,
      showCreate: false,
      showPhone: false
    }
  },

  computed: {
    ...mapState('agent', { a: 'agent' }),
    ...mapState('bank', ['banks']),
    ...mapState('vip', ['vipList']),
    ...mapState('level', ['levels']),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },
    showPassword () {
      if (this.agent.temp) {
        return window.atob(this.agent.temp)
      }
    }
  },

  async created () {
    console.log('crash', this.a)
    await this.find({ id: this.$route.params.id, params: this.params })
    this.agent = Object.assign({}, this.a)
    console.log(this.agent)
    await this.getBanks({ status: 'active' })
    await this.getVips()
    await this.getLevels()
  },

  watch: {
    a (val) {
      this.agent = Object.assign({}, val)

      console.log('this.agent', this.agent)
    }
  },

  methods: {
    ...mapActions('agent', ['find']),
    ...mapActions('bank', { getBanks: 'get' }),
    ...mapActions('vip', { getVips: 'get' }),
    ...mapActions('level', { getLevels: 'get' }),

    openAgentPopup () {
      if (!this.agent.referrer) return
      console.log(this.agent, 'openAgentPopup')
      window.open(
        `${process.env.VUE_APP_URL}/agent/${this.agent.referrer.id}/info/undeleted`,
        '',
        `width=${1200},height=${window.innerHeight}`
      )
    }
  }

}

</script>
